// extracted by mini-css-extract-plugin
module.exports = {"download_app_button":"DownloadAppButton_download_app_button__i5yfe","title":"DownloadAppButton_title__qUDTw","icons":"DownloadAppButton_icons__Nrc2o"};